<template>
  <div class="page">
    <p style="text-align: center; margin-bottom: 40px">
      <img src="https://wisuda.pspp-integrated.com/logo.jpeg" width="120" />
    </p>

    <h3 style="text-align: center">Aplikasi Wisuda PSPP</h3>

    <form @submit.prevent="login">
      <div class="form-group">
        <label>User</label>
        <select v-model="user.id">
          <option v-for="(item, index) in users" :key="index" :value="item.id">
            {{ item.nama }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Password</label>
        <input type="password" v-model="user.password" />
      </div>
      <div>
        <button type="submit" :disabled="loading">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import * as api from "../api";
export default {
  name: "app",
  data() {
    return {
      printer: false,
      users: [],
      user: {
        platform: "CHECKIN_WISUDA",
      },
      loading: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      api
        .postJson("/v1/users/login", this.user)
        .then((r) => {
          this.loading = false;
          if (!r.valid) {
            alert("Login gagal");
          } else {
            const data = {
              id: r.data.id,
              nama: r.data.nama,
              login: true,
            };
            localStorage.setItem("login", JSON.stringify(data));
            this.$router.go(-1);
          }
        })
        .catch((e) => {
          this.loading = false;
          alert("Server Error");
        });
    },
  },
  mounted() {
    api.get("/v1/users/getByPlatform?platform=CHECKIN_WISUDA").then((r) => {
      this.users = r;
    });
  },
};
</script>

<style lang="scss" scoped>
.page {
  .form-group {
    margin-bottom: 15px;
    label {
      display: block;
      margin-bottom: 5px;
    }
  }

  input,
  select {
    background: #fff;
    border: 1px solid #999;
    border-radius: 8px;
    padding: 10px;
    width: 100%;
    outline: none;
    &:focus {
      border-color: #147BFE;
    }
  }
  input {
    width: calc(100% - 22px);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue